import { AxiosResponse } from "axios";

const isValidResponse = (response: AxiosResponse<any>) => {
  return response?.status === 200;
};

export { isValidResponse };
